<template>
  <div class="first">
    <div class="menubox">
      <div class="logo animated fadeIn">
        <a href="./index.html">
          <img src="../../public/image/dddlogo2.png" alt />
        </a>
      </div>
      <div class="list">
        <ul>
          <li
            class="animated fadeInDown"
            style="animation-delay: 0.2s"
            :class="{ active: menuindex == 0}"
            @click="changeMenu(0)"
          >
            <a href="./about.html" target="_self">{{ $t("list")[0] }}</a>
            <div class="pList" :class="{pList1:this.$i18n.locale=='en'}">
              <div class="pCon" >
                <div class="line"></div>
                <div class="aps">
                  <p
                    v-for="(item, index) in $t('top').aList"
                    :key="index"
                    class="animated fadeInUp"
                    :style="{ animationDelay: `${index * 0.1 + 's'}` }"
                    @click.stop="goto('about', index)"
                  >
                    {{ item }}
                  </p>
                </div>
              </div>
            </div>
          </li>
          <!-- <li
            class="animated fadeInDown"
            style="animation-delay: 0.3s"
            :class="{active:menuindex==1,shortMenu:shortMenu!=0}"
            @click="changeMenu(1)"
          >
            <a href="">品牌故事</a>
          </li> -->
          
          <li
            class="animated fadeInDown"
            style="animation-delay: 0.5s"
            :class="{ active: menuindex == 3}"
            @click="changeMenu(3)"
          >
            <a href="./tech.html" target="_self">{{ $t("list")[2] }}</a>
            <div class="pList" :class="{pList2:this.$i18n.locale=='en'}">
              <div class="pCon">
                <div class="line"></div>
                <div class="aps">
                  <p
                    v-for="(item, index) in $t('top').tList"
                    :key="index"
                    class="animated fadeInUp"
                    :style="{ animationDelay: `${index * 0.1 + 's'}` }"
                    @click.stop="goto('tech', index)"
                  >
                    {{ item }}
                  </p>
                </div>
              </div>
            </div>
          </li>
          <li
            class="animated fadeInDown"
            style="animation-delay: 0.4s"
            :class="{ active: menuindex == 2}"
            @click="changeMenu(2)"
          >
            <a href="./duty.html" target="_self">{{ $t("list")[1] }}</a>
          </li>
          <li
            class="animated fadeInDown"
            style="animation-delay: 0.6s"
            :class="{ active: menuindex == 4}"
            @click="changeMenu(4)"
          >
            <a href="./news.html" target="_self">{{ $t("list")[3] }}</a>
            <div class="pList">
              <div class="pCon" >
                <div class="line"></div>
                <div class="aps">
                  <p
                    v-for="(item, index) in $t('top').nList"
                    :key="index"
                    class="animated fadeInUp"
                    :style="{ animationDelay: `${index * 0.1 + 's'}` }"
                    @click.stop="goto('news', index)"
                  >
                    {{ item }}
                  </p>
                </div>
              </div>
            </div>
          </li>
          <li
            class="animated fadeInDown"
            style="animation-delay: 0.7s"
            :class="{ active: menuindex == 5}"
            @click="changeMenu(5)"
          >
            <a href="./contact.html" target="_self">{{ $t("list")[4] }}</a>
            <div class="pList" :class="{pList1:this.$i18n.locale=='en'}">
              <div class="pCon" >
                <div class="line"></div>
                <div class="aps">
                  <p
                    v-for="(item, index) in $t('top').cList"
                    :key="index"
                    class="animated fadeInUp"
                    :style="{ animationDelay: `${index * 0.1 + 's'}` }"
                    @click.stop="goto('contact', index)"
                  >
                    {{ item }}
                  </p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="icon" >
        <!-- <div class="i_item">
          <i class="iconfont icon-geren"></i>
        </div> -->
        <div class="i_item" style="visibility: hidden;">
          <i class="iconfont icon-sousuo" @click="searchDialog = true"></i>
        </div>
        <div class="i_item">
          <i
            v-if="$i18n.locale == 'zh-CN'"
            class="iconfont icon-yingwenyuyan"
            @click="changeLan('en')"
          ></i>
          <i
            v-if="$i18n.locale == 'en'"
            class="iconfont icon-zhongwenyuyan"
            @click="changeLan('zh-CN')"
          ></i>
        </div>
      </div>
    </div>
    <div class="search" :class="{ active_search: searchDialog }">
      <div class="search_box">
        <input type="text" placeholder="SEARCH" />
        <i class="el-icon-close" @click="searchDialog = false"></i>
      </div>
    </div>
    <Pmenu />
  </div>
</template>

<script>
import Pmenu from "../components/pmenu";
import { mapState } from "vuex";
import { setup } from "../local/index";
export default {
  data() {
    return {
      searchDialog: false,
      aList: [
        "集团介绍",
        "发展历程",
        "集团品牌",
        "荣誉资质",
        "企业文化",
        "战略愿景",
      ],
      tList: ["氟化工领域","空调安装领域", "水道领域", "热泵领域", "新业态领域"],
      nList: ["集团动态", "行业动态"],
      cList: ["人力资源", "在线留言", "联系方式"],
    };
  },
  props: ["menuindex"],
  components: { Pmenu },
  mounted() {},
  computed: {
    ...mapState(["shortMenu"]),
  },
  methods: {
    changeLan(n) {
      this.$i18n.locale = n;
      window.localStorage.setItem("language", n);
      setup(n);
      window.location.reload();
    },
    goto(page, n) {
      if (page == "about" && n > 1) {
        const link = `./culture.html?index=${n - 2}`;
        window.open(link, "_self");
      } else if (page == "contact" && n === 0) {
        window.open("./contact.html", "_self");
      } else if (page == "contact" && n === 1) {
        window.open("./message.html", "_self");
      } else if (page == "contact" && n === 2) {
        window.open("./human.html", "_self");
      } else {
        const link = `./${page}.html?index=${n}`;
        window.open(link, "_self");
      }
    },
    changeMenu(id) {
      this.menuindex = id;
    },
  },
};
</script>

<style lang="scss" scoped>
.first {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #019bdb;
  z-index: 10;
  transition: all 600ms;
  .menubox {
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      width: 30%;
      cursor: pointer;
      img {
        height: 34px;
      }
    }
    .list {
      width: 36%;
      margin-left: auto;
      margin-right: 100px;
      ul {
        display: flex;
        justify-content: space-between;
        li {
          list-style: none;
          line-height: 90px;
          position: relative;
          transition: all 600ms;
          cursor: pointer;

          &:nth-child(1){
            .aps{
              p:nth-child(2){
                display: none;
              }
            }
          }

          &::after {
            position: absolute;
            display: inline-block;
            content: "";
            top: 0;
            left: 30%;
            width: 0;
            height: 2px;
            background-color: white;
            transition: all 600ms;
          }
          &:hover {
            &::after {
              width: 40%;
            }
            a {
              color: white;
            }
          }
          a {
            font-weight: 300;
            font-size: 16px;
            color: white;
            // opacity: .5;
            font-family: "SOURCEHANSANSCN-LIGHT";
            transition: all 300ms;
          }
          .pList {
            position: absolute;
            left: 0;
            transform: translateX(-47px);
            top: 100%;
            width: 158px;
            display: none;
            .pCon {
              width: 100%;
              position: relative;
              background-color: #019bdb;
              padding-bottom: 20px;
              transition: all 600ms;
              .line {
                width: 1px;
                height: 90%;
                background-color: rgba(255, 255, 255, 0.2);
                position: absolute;
                left: 20px;
                top: 5%;
              }
              .aps {
                width: 95%;
                padding: 0 0 0 9px;
                
                p {
                  margin: 0;
                  line-height: 30px;
                  text-align: left;
                  padding-left: 40px;
                  font-size: 14px;
                  color: white;
                  font-family: "SOURCEHANSANSCN-EXTRALIGHT";
                  padding-top: 15px;
                  cursor: pointer;
                  position: relative;
                  opacity: 0.7;
                  transition: all 600ms;

                  &::before {
                    width: 15px;
                    height: 15px;
                    border: 1px solid #ffffff;
                    border-radius: 50%;
                    display: inline-block;
                    position: absolute;
                    left: 3px;
                    top: 50%;
                    content: "";
                    opacity: 0;
                    transition: all 600ms;
                  }
                  &::after {
                    width: 6px;
                    height: 6px;
                    background: #ffffff;
                    border-radius: 50%;
                    display: inline-block;
                    position: absolute;
                    left: 9px;
                    top: 63%;
                    content: "";
                    opacity: 0;
                    transition: all 600ms;
                  }
                  
                  &:hover {
                    opacity: 1;
                    &::before,
                    &::after {
                      opacity: 0.7;
                    }
                  }
                }
              }
            }
          }
          .pList1{
            width: 235px;
          }
          .pList2{
            width: 300px;
          }
          &:hover {
            .pList {
              display: block;
            }
          }
        }
        li:nth-child(3) {
          .pList {
            width: 250px;
            left: -95px;
            .pCon {
              .aps {
                p {
                  &::before {
                    width: 15px;
                    height: 15px;
                    border: 1px solid #ffffff;
                    border-radius: 50%;
                    display: inline-block;
                    position: absolute;
                    left: 7%;
                    top: 50%;
                    content: "";
                    transition: all 600ms;
                  }
                  &::after {
                    left: 9.4%;
                  }
                  &:hover {
                    opacity: 1;
                    &::before,
                    &::after {
                      opacity: 0.7;
                    }
                  }
                }
              }
            }
          }
        }
        .shortMenu {
          line-height: 60px;
        }
        .active {
          &::after {
            position: absolute;
            display: inline-block;
            content: "";
            top: 0;
            left: 30%;
            width: 40%;
            height: 2px;
            background-color: white;
            transition: all 600ms;
          }
        }
      }
    }
    .icon {
      // margin-left: 80px;
      // width: 10%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      transform: translateY(-1px);
      .i_item {
        cursor: pointer;
        width: 50%;
        text-align: end;
        padding: 0 20px;
        i {
          color: white;
          font-size: 20px;
          transition: all 300ms;
          &:hover {
            color: white;
          }
        }
      }
      .i_item:nth-child(2) {
        padding-right: 0;
        position: relative;
        &::before {
          visibility: hidden;
          display: inline-block;
          content: "";
          position: absolute;
          left: 0;
          top: 28%;
          height: 10px;
          width: 1px;
          background-color: white;
        }
      }
    }
  }
  .search {
    width: 100%;
    position: fixed;
    top: 0;
    height: 91px;
    background-color: white;
    transform: translateY(-90px);
    transition: all 600ms;
    .search_box {
      width: 90%;
      height: 90px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      input {
        width: 60%;
        margin-left: 20%;
        border: none;
        border-bottom: 1px solid #ededed;
        outline: none;
        padding: 10px;
        font-size: 16px;
        color: #333333;
        &::-webkit-input-placeholder {
          color: #d8d8d8;
        }
      }
      i {
        margin-left: auto;
        margin-right: 60px;
        cursor: pointer;
      }
    }
  }
  .active_search {
    transform: translateY(0);
  }
}
@media screen and (max-width: 1000px) {
  .first {
    .menubox {
      display: none;
    }
  }
}
</style>
